import { Injectable } from '@angular/core';
import { AppService } from '../shared/app.service';
import { HttpClient } from '@angular/common/http';
import { StateKey, state2, cacheTimeMax, IStateOptions, ISearchResult, IStateOptions2 } from '../shared/state';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ICodeIdOmschrijving, GlobalDataService } from '../shared/global-data.service';
import { Observable, of } from 'rxjs';
import { ICommonSearchArgs } from 'src/app/shared/common-search-args';


export interface IFullTextSearchArgs extends ICommonSearchArgs {
  DiversePublicatieBestemmingIdAtHome?: number;
}

export interface IFullTextSearchResult {
  hasMoreResults: boolean;
  zoekResults: IFullTextSearchResultItem[];
}

export interface IFullTextSearchResultItem {
  DatumZitting: Date;
  ZittingId: number;
  SoortZitting: string;
  AgendapuntId: number;
  Betreft: string;
  Titel: string;
  DocumentTitel: string;
  DocumentAgendapuntId: number;
  Volgnummer: string;
  isPuntBreak: boolean;
  isZittingBreak: boolean;
  Verwijzing: string;
  Id?: string;
  Ext?: string;
}

export interface IPeriodeFilter {
  Title: string;
  arg: string | null;
  Tooltip?: string;
}

@Injectable()
export class ZoekDataResolver implements Resolve<ICodeIdOmschrijving[]> {
  constructor(private globalDataService: GlobalDataService) {
  }

  // resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): ICodeIdOmschrijving[] | Observable<ICodeIdOmschrijving[]> | Promise<ICodeIdOmschrijving[]> {
  //   return this.globalDataService.getSoortenZitting();
  // }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any | Observable<any> | Promise<any> {
    return { newSearch: route.data['newSearch'], soortenZitting: this.globalDataService.getSoortenZitting() };
  }


}

@Injectable()
export class ZoekService {

  statekey: StateKey = 'zoekresultaten';
  periodeFilters: IPeriodeFilter[];
  constructor(private appService: AppService,
    private http: HttpClient) {
    this.periodeFilters = [
      { Title: 'Huidig jaar', arg: 'y' },
      { Title: 'Afgelopen maand', arg: '-1m' },
      { Title: 'Afgelopen jaar', arg: '-1y' },
      { Title: 'Afgelopen 2 jaar', arg: '-2y' },
      { Title: 'Aangepaste periode', arg: 'C' }
    ];

  }

  zoek(zoekArg: ICommonSearchArgs) {
    const url = this.appService.getUrl('api/zoeken/zoek');
    if (!zoekArg.SearchFor) {
      const emptyResult: ISearchResult<IFullTextSearchResultItem> = { hasMoreResults: false, items: [] };
      return of(emptyResult);
    }

    // stateOptions worden gezet als state parameter op de route
    // niet via de queryParams omdat deze niet in de url mogen behouden worden
    const stateoptions = window.history.state as IStateOptions2;
    // als concat false is zetten we CurrentPage op 0, dit behandelt de situatie waarbij
    // een url geplakt zou worden met CurrentPage>0. In dit geval moeten we resultaten vanaf nul ophalen
    // omdat er nog geen resultaten zijn waarop we concat kunnen uitvoeren.
    if (!stateoptions.concat) { stateoptions.page = 0; zoekArg.CurrentPage = 0; }
    const newZoekArg = { ...zoekArg, CurrentPage: stateoptions.page };
    return state2.getSearchResultOrDefault(this.statekey, this.http.post<IFullTextSearchResultItem[]>(url, newZoekArg), stateoptions);
  }

  getPeriodeFilters() {
    return this.periodeFilters;
  }

}
